import React from "react";

// Which document's <body> to portal into - defaults to the real page, but
// /lab's IsolatedFrame (src/lab/lab-primitives.tsx) overrides this to its
// own iframe document, so components using AppendBody stay contained in
// their preview instead of escaping to the real page (an explicit
// `document.body` reference can't be scoped by DOM/iframe nesting alone,
// since it's the same global object regardless of where the calling
// component happens to be portaled from).
export const AppendBodyTargetContext = React.createContext<Document | null>(
  null
);
